import React, { useState, useEffect } from "react";
import s from "./index.module.css";

//assets
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import Pager from "../../Shared/Pagination/Pagination";

//material
import {
  Alert,
  CircularProgress,
  Grid,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  Skeleton,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import AgencyModal from "../../Shared/AgencyModal";
import { getAllActivesGameOffers } from "../../../api/games/GamesService";
import { Currency } from "../../../helpers/currencyConvert";

const mock = [
  {
    game: "La Tarasca",
    modality: "Serie Musical 550",
    controll: 1819472,
    agency: 86,
    price: 500,
    operationDate: "06/03/2023",
    settlementDate: "21/06/2023",
  },
  {
    game: "La Tarasca",
    modality: "El gran truco 520",
    controll: 543242,
    agency: 56,
    price: 1000,
    operationDate: "16/12/2023",
    settlementDate: "02/01/2024",
  },
  {
    game: "La Tarasca",
    modality: "TA - TE - TI 510",
    controll: 1819472,
    agency: 86,
    price: 500,
    operationDate: "01/11/2023",
    settlementDate: "08/11/2023",
  },
  {
    game: "La Tarasca",
    modality: "Serie Musical 550",
    controll: 1819472,
    agency: 86,
    price: 500,
    operationDate: "06/07/2023",
    settlementDate: "23/08/2023",
  },
];
// function simulateAsync(time, fail) {
//   return new Promise((resolve, reject) => {
//     setTimeout(() => {
//       if (fail) {
//         reject(new Error("Falló el llamado asincrónico"));
//       } else {
//         resolve("Respuesta del llamado asincrónico");
//       }
//     }, time);
//   });
// }

const cellStyles = {
  fontFamily: "Roboto, sans-serif",
  fontSize: "16px",
  fontWeight: "400",
  borderBottom: "1px solid rgba(0, 0, 0, 0.455)",
  cursor: "pointer",
};

export const PremiosPagadosInstantaneos = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { textColor } = useSelector((state) => state.local);
  const { allGameOffersActive } = useSelector((state) => state.gamma);
  const organization = useSelector((state) => state.gamma.activeOrganization);
  //Estados
  const [openError, setOpenError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [filters, setFilters] = useState({
    date: null,
    agencyId: null,
    gameId: 0,
  });
  const [agency, setAgency] = useState(null);
  const [input, setInput] = useState("");
  const [openModal, setOpenModal] = useState(false);

  //Paginado
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [pageCustom, setPageCustom] = useState(1);

  const getData = () => {
    setItems(mock);
    // setLoading(true);
    // simulateAsync(2000, false)
    //   .then(() => {
    //     setItems(mock);
    //     setLoading(false);
    //   })
    //   .catch(() => {
    //     setOpenError(true)
    //     setLoading(false)
    //   })
  };

  useEffect(() => {
    getData();
  }, [page, pageSize]);

  //   useEffect(() => {
  //     getAllActivesGameOffers(organization?.id, dispatch);
  //   }, [])

  //   useEffect(() => {
  //     if(agency === null){
  //       setInput('');
  //     }else{
  //       setInput(`${agency?.name} (${agency?.number}${agency?.subNumber ? ` - ${agency.subNumber}` : ''})`);
  //       setFilters(prev => ({...prev, agencyId: agency.id}));
  //     }
  //   }, [agency])

  return (
    <>
      <Grid container className={s.container}>
        <Grid item xs={12} className={s.header}>
          <Grid item container xs={12} className={s.titleContainer}>
            <ArrowBackIcon
              sx={{ color: "primary.main", fontSize: 40 }}
              onClick={() => navigate("../reportes")}
              className={s.arrow}
            />
            <Grid
              item
              xs={10}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <h4>{t("preprintedPaidPrizes")}</h4>
            </Grid>
          </Grid>
        </Grid>

        <Grid item container xs={11.5} className={s.filters}>
          <Grid item xs={11.4}>
            <h4
              style={{
                fontSize: "24px",
                fontWeight: 300,
              }}
            >
              {t("filter")}
            </h4>
          </Grid>
          <Grid item xs={3} className={s.item}>
            <FormControl sx={{ width: "95%" }}>
              <InputLabel>{t("game")}</InputLabel>
              <Select
                value={filters.gameId}
                label={t("game")}
                sx={{ width: "100%" }}
                onChange={(e) =>
                  setFilters((prev) => ({ ...prev, gameId: e.target.value }))
                }
              >
                <MenuItem value={0}>{t("select")}</MenuItem>
                {allGameOffersActive?.map((item, i) => {
                  if (item?.modality?.mode?.id === 1) {
                    return (
                      <MenuItem key={i} value={item.modality?.game?.id}>
                        {item?.modality?.game?.name}
                      </MenuItem>
                    );
                  }
                })}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={4} className={[s.item, s.init1]}>
            <FormControl sx={{ width: "70%" }}>
              <TextField
                label={!!agency?.name ? `${t("clear")} X` : t("selectAgency")}
                value={input}
                InputLabelProps={{
                  shrink: !!agency?.name,
                  onClick: () => setAgency(null),
                }}
                disabled
                sx={{ width: "100%" }}
              />
            </FormControl>
            <Button sx={{ ml: 1 }} onClick={() => setOpenModal(true)}>
              {t("consult")}
            </Button>
          </Grid>
          <Grid item xs={3} className={[s.item, s.init2]}>
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              sx={{ width: "95%" }}
            >
              <DatePicker
                label={!!filters?.date ? `${t("clear")} X` : t("date")}
                onChange={(e) => setFilters((prev) => ({ ...prev, date: e }))}
                inputFormat="DD/MM/YYYY"
                value={filters.date || null}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    sx={{ width: "95%" }}
                    InputLabelProps={{
                      onClick: () =>
                        setFilters((prev) => ({ ...prev, date: null })),
                    }}
                  />
                )}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item container xs={1} className={[s.item, s.init3]}>
            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Button variant="contained">{t("process")}</Button>
            </Grid>
          </Grid>
        </Grid>

        {loading ? (
          <Grid item xs={12} className={s.loader}>
            <CircularProgress size={"4rem"} />
          </Grid>
        ) : (
          <Grid item container xs={12} className={s.data}>
            {items?.length ? (
              <Grid item xs={11}>
                <TableContainer className={s.tableContainer}>
                  <Table>
                    <TableHead sx={{ backgroundColor: "primary.main" }}>
                      <TableCell
                        sx={{
                          color: textColor,
                          fontSize: "18px",
                          fontWeight: 500,
                          fontFamily: "Roboto, sans-Serif",
                        }}
                      >
                        {t("game")}
                      </TableCell>
                      <TableCell
                        sx={{
                          color: textColor,
                          fontSize: "18px",
                          fontWeight: 500,
                          fontFamily: "Roboto, sans-Serif",
                        }}
                      >
                        {t("modality")}
                      </TableCell>
                      <TableCell
                        sx={{
                          color: textColor,
                          fontSize: "18px",
                          fontWeight: 500,
                          fontFamily: "Roboto, sans-Serif",
                        }}
                      >
                        {t("control")}
                      </TableCell>
                      <TableCell
                        sx={{
                          color: textColor,
                          fontSize: "18px",
                          fontWeight: 500,
                          fontFamily: "Roboto, sans-Serif",
                        }}
                      >
                        {t("agency")}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          color: textColor,
                          fontSize: "18px",
                          fontWeight: 500,
                          fontFamily: "Roboto, sans-Serif",
                        }}
                      >
                        {t("prize")}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          color: textColor,
                          fontSize: "18px",
                          fontWeight: 500,
                          fontFamily: "Roboto, sans-Serif",
                        }}
                      >
                        {t("operationDate")}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          color: textColor,
                          fontSize: "18px",
                          fontWeight: 500,
                          fontFamily: "Roboto, sans-Serif",
                        }}
                      >
                        {t("settlementDate")}
                      </TableCell>
                    </TableHead>
                    <TableBody>
                      {items?.map((item, i) => (
                        <React.Fragment key={item.id}>
                          <TableRow
                            sx={{
                              "&:hover": { backgroundColor: "secondary.light" },
                            }}
                          >
                            <TableCell
                              sx={{
                                ...cellStyles,
                                backgroundColor:
                                  i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                              }}
                            >
                              {item.game}
                            </TableCell>
                            <TableCell
                              sx={{
                                ...cellStyles,
                                backgroundColor:
                                  i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                              }}
                            >
                              {item.modality}
                            </TableCell>
                            <TableCell
                              sx={{
                                ...cellStyles,
                                backgroundColor:
                                  i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                              }}
                            >
                              {item.controll}
                            </TableCell>
                            <TableCell
                              sx={{
                                ...cellStyles,
                                backgroundColor:
                                  i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                              }}
                            >
                              {item.agency}
                            </TableCell>
                            <TableCell
                              align="center"
                              sx={{
                                ...cellStyles,
                                backgroundColor:
                                  i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                              }}
                            >
                              <Currency value={item.price} />
                            </TableCell>
                            <TableCell
                              align="center"
                              sx={{
                                ...cellStyles,
                                backgroundColor:
                                  i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                              }}
                            >
                              {item.operationDate}
                            </TableCell>
                            <TableCell
                              align="center"
                              sx={{
                                ...cellStyles,
                                backgroundColor:
                                  i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                              }}
                            >
                              {item.settlementDate}
                            </TableCell>
                          </TableRow>
                        </React.Fragment>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            ) : (
              <Grid
                item
                xs={12}
                sx={{
                  minHeight: "300px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "1.8rem",
                  fontFamily: "Roboto, sans-serif",
                  fontWeight: 300,
                }}
              >
                {t("noResults")}
              </Grid>
            )}
          </Grid>
        )}
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            mb: "50px",
          }}
        >
          <Pager
            pageSize={pageSize}
            setPageSize={setPageSize}
            page={page}
            setPage={setPage}
            totalPages={totalPages}
            pageCustom={pageCustom}
            setPageCustom={setPageCustom}
          />
        </Grid>
      </Grid>
      <Snackbar
        open={openError}
        autoHideDuration={6000}
        onClose={() => setOpenError(false)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        <Alert
          variant="filled"
          onClose={() => setOpenError(false)}
          severity="error"
          sx={{ width: "100%" }}
        >
          {t("tryInOtherMoment")}
        </Alert>
      </Snackbar>
      {openModal ? (
        <AgencyModal
          open={openModal}
          setOpen={setOpenModal}
          selectAgency={setAgency}
        />
      ) : null}
    </>
  );
};
